import { Navigate } from 'react-router-dom'
// project imports
import DashboardLayout from '../layout/dashboard-layout'
import ApplicationsPage from '../pages/Applications/applications';
import OrgSettings from '../pages/OrgSettings/OrgSettings';
import { AuthRoute } from './auth-route';
import { USER_ROLES } from '../utils/constants';
import Logout from '../pages/Logout/Logout';
import UsersPage from '../pages/Users/Users';
// ==============================|| MAIN ROUTING ||============================== //

const DashboardRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: <ApplicationsPage />
    },
    {
      path: '/users',
      element: <AuthRoute requiredRoles={USER_ROLES.all}><UsersPage /></AuthRoute>
    },
    {
      path: '/settings',
      element: <AuthRoute requiredRoles={USER_ROLES.all}><OrgSettings /></AuthRoute>
    },
    {
      path: '/logout',
      element: <Logout />
    },
    {
      path: "*",
      element: <Navigate to="/" replace />
    }
  ]
};

export default DashboardRoutes;
